import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        this.resize() // Resize on initial load if the textarea has content
    }

    resize() {
        this.element.style.height = 'auto' // Reset height to auto
        this.element.style.height = `${this.element.scrollHeight}px` // Set height based on content
        this.element.style.overflowY = 'hidden' // Hide any scrollbars
    }

    adjust() {
        this.resize() // Adjust the textarea height as the user types
    }
}
